export default "__VITE_ASSET__BZ_DxHr1__"